"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constants = void 0;
exports.Constants = {
    UnarmedStrikeDamage: 5,
    OffHandDamageMultiplier: .5,
    TwoHandDamageMultiplier: 1.5,
    HasteDivisor: 100,
};
